// import React, { useState } from "react";
// import { useSelector } from "react-redux";
// import useApi from "../../CustomHooks/useApi";

// const Verification = () => {
//   const userId = useSelector((state) => state.auth.employeeDetails?.userId);

//   const { callApi: verifyPan, loading: loadingPan } = useApi("/kyc/verify/pan", "POST");
//   const { callApi: verifyAadhaar, loading: loadingAadhaar } = useApi("/kyc/verify/aadhaar", "POST");
//   const { callApi: verifyPanAadhaarLink, loading: loadingLink } = useApi("/kyc/verify/pan-aadhaar-link", "POST");
//   const { callApi: verifyBenePennyless, loading: loadingPennyless } = useApi("/kyc/verify/bene/pennyless", "POST");
//   const { callApi: verifyBenePennyDrop, loading: loadingPennyDrop } = useApi("/kyc/verify/bene/penny-drop", "POST");
//   const { callApi: verifyMobileToUpi, loading: loadingMobile } = useApi("/kyc/verify/mobile-to-upi", "POST");
//   const { callApi: verifyUpi, loading: loadingUpi } = useApi("/kyc/verify/upi", "POST");

//   const [activeTab, setActiveTab] = useState("pan");
//   const [formData, setFormData] = useState({});
//   const [resultData, setResultData] = useState(null);
//   const [errorMsg, setErrorMsg] = useState("");

//   const servicesConfig = {
//     pan: {
//       title: "PAN Verification",
//       fields: [{ name: "panNumber", label: "PAN Number", placeholder: "e.g. AAICP3293R" }],
//       apiCall: verifyPan,
//       loading: loadingPan,
//     },
//     // aadhaar: {
//     //   title: "Aadhaar Verification",
//     //   fields: [{ name: "aadhaarNumber", label: "Aadhaar Number", placeholder: "12-digit number" }],
//     //   apiCall: verifyAadhaar,
//     //   loading: loadingAadhaar,
//     // },
//     panAadhaar: {
//       title: "PAN-Aadhaar Link Check",
//       fields: [
//         { name: "pan", label: "PAN Number", placeholder: "e.g. GDCPS0678M" },
//         { name: "aadhaar", label: "Aadhaar Number", placeholder: "12-digit number" },
//       ],
//       apiCall: verifyPanAadhaarLink,
//       loading: loadingLink,
//     },
//     benePennyless: {
//       title: "Beneficiary (Penny-Less)",
//       fields: [
//         { name: "accountNumber", label: "Account Number", placeholder: "e.g. 1234567890" },
//         { name: "ifsc", label: "IFSC Code", placeholder: "e.g. HDFC0001234" },
//       ],
//       apiCall: verifyBenePennyless,
//       loading: loadingPennyless,
//       note: "Free verification. No wallet deduction.",
//     },
//     benePennyDrop: {
//       title: "Beneficiary (Penny Drop)",
//       fields: [
//         { name: "accountNumber", label: "Account Number", placeholder: "e.g. 1234567890" },
//         { name: "ifsc", label: "IFSC Code", placeholder: "e.g. HDFC0001234" },
//       ],
//       apiCall: verifyBenePennyDrop,
//       loading: loadingPennyDrop,
//       note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
//     },
//     mobileUpi: {
//       title: "Mobile to UPI Lookup",
//       fields: [{ name: "mobileNumber", label: "Mobile Number", placeholder: "10-digit number" }],
//       apiCall: verifyMobileToUpi,
//       loading: loadingMobile,
//     },
//     upi: {
//       title: "UPI ID Verification",
//       fields: [{ name: "upiId", label: "UPI ID", placeholder: "e.g. 8376060847@upi" }],
//       apiCall: verifyUpi,
//       loading: loadingUpi,
//     },
//   };

//   const handleInputChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleTabSwitch = (key) => {
//     setActiveTab(key);
//     setFormData({});
//     setResultData(null);
//     setErrorMsg("");
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setResultData(null);
//     setErrorMsg("");

//     const activeService = servicesConfig[activeTab];
    
//     try {
//       const queryString = new URLSearchParams(formData).toString();
//       const response = await activeService.apiCall(null, `?${queryString}`);
      
//       // Handle logical API errors (like your 202 Pennydrop error)
//       if (response?.error || response?.error_code || response?.status === "failed") {
//         setErrorMsg(response.message || response.error || "Verification failed.");
//         return;
//       }

//       // Handle standard successes
//       if (response && (response.status === "success" || response.status_code === 200)) {
//         setResultData(response);
//       } else {
//         setErrorMsg("Unexpected response format received from server.");
//       }
//     } catch (err) {
//       setErrorMsg(err.message || "An error occurred during verification.");
//     }
//   };

//   const activeService = servicesConfig[activeTab];

//   // --- UI HELPER COMPONENTS --- //
//   const ResultCard = ({ label, value, isBoolean }) => (
//     <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 flex flex-col">
//       <span className="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-1">
//         {label}
//       </span>
//       {isBoolean ? (
//         <span className={`font-bold ${value ? 'text-green-600' : 'text-red-600'}`}>
//           {value ? "✓ Yes / Verified" : "✗ No / Unverified"}
//         </span>
//       ) : (
//         <span className="text-[#12345A] font-semibold text-lg capitalize">
//           {value || "N/A"}
//         </span>
//       )}
//     </div>
//   );

//   const renderCleanResults = () => {
//     if (!resultData) return null;

//     // Handle APIs that wrap data in a "data" object vs flat structure
//     const data = resultData.data || resultData; 

//     return (
//       <div className="mt-8 border border-green-200 rounded-xl overflow-hidden shadow-sm bg-white">
//         <div className="bg-green-50 border-b border-green-200 px-6 py-4 flex items-center">
//           <svg className="w-6 h-6 text-green-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
//           </svg>
//           <h4 className="text-lg font-bold text-green-800">Verification Successful</h4>
//         </div>
        
//         <div className="p-6">
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            
//             {/* PAN RESULTS */}
//             {activeTab === 'pan' && (
//               <>
//                 <ResultCard label="Registered Name" value={data.fullName} />
//                 <ResultCard label="PAN Number" value={data.panNumber} />
//                 <ResultCard label="Category" value={data.category} />
//               </>
//             )}

//             {/* AADHAAR RESULTS */}
//             {/* {activeTab === 'aadhaar' && (
//               <>
//                 <ResultCard label="Full Name" value={data.fullName} />
//                 <ResultCard label="Gender" value={data.gender === "M" ? "Male" : data.gender === "F" ? "Female" : data.gender} />
//                 <ResultCard label="DOB" value={data.dob} />
//                 <ResultCard label="State" value={data.state} />
//               </>
//             )} */}

//             {/* PAN-AADHAAR LINK RESULTS */}
//             {activeTab === 'panAadhaar' && (
//               <>
//                 <ResultCard label="Link Status" value={data.is_linked} isBoolean={true} />
//                 <ResultCard label="System Message" value={data.message} />
//                 <ResultCard label="PAN Checked" value={data.pan_number} />
//               </>
//             )}

//             {/* BENEFICIARY (PENNYLESS & PENNYDROP) RESULTS */}
//             {(activeTab === 'benePennyless' || activeTab === 'benePennyDrop') && (
//               <>
//                 <ResultCard label="Account Holder Name" value={data.full_name || data.fullName} />
//                 <ResultCard label="Account Exists" value={data.account_exists || data.accountExists} isBoolean={true} />
//                 {data.txnRefId && <ResultCard label="Transaction Ref ID" value={data.txnRefId} />}
//               </>
//             )}

//             {/* MOBILE TO UPI RESULTS */}
//             {activeTab === 'mobileUpi' && (
//               <>
//                 <ResultCard label="Registered Name" value={data.name} />
//                 <ResultCard label="UPI ID" value={data.upi_id || data.upiId} />
//               </>
//             )}

//             {/* UPI ID RESULTS */}
//             {activeTab === 'upi' && (
//               <>
//                 <ResultCard label="Name at Bank" value={data.name_at_bank || data.nameAtBank} />
//                 <ResultCard label="Account Status" value={data.account_exists || data.accountExists} isBoolean={true} />
//               </>
//             )}

//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-6 font-sans">
//       <div className="max-w-6xl mx-auto bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden flex flex-col md:flex-row">
        
//         {/* SIDEBAR TABS */}
//         <div className="w-full md:w-1/3 bg-[#12345A] text-white flex flex-col">
//           <div className="p-6 border-b border-[#1c4d85]">
//             <h2 className="text-2xl font-bold tracking-wide">Verification Hub</h2>
//             <p className="text-sm text-gray-300 mt-1">Select a service to verify identity</p>
//           </div>
//           <div className="flex-1 overflow-y-auto p-4 space-y-2">
//             {Object.entries(servicesConfig).map(([key, config]) => (
//               <button
//                 key={key}
//                 onClick={() => handleTabSwitch(key)}
//                 className={`w-full text-left px-4 py-3 rounded-lg transition-all duration-300 font-medium ${
//                   activeTab === key
//                     ? "bg-white text-[#12345A] shadow-md"
//                     : "text-gray-300 hover:bg-[#1c4d85] hover:text-white"
//                 }`}
//               >
//                 {config.title}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* MAIN CONTENT AREA */}
//         <div className="w-full md:w-2/3 p-8">
//           <h3 className="text-3xl font-bold text-[#12345A] mb-6 border-b pb-4">
//             {activeService.title}
//           </h3>

//           {/* DYNAMIC FORM */}
//           <form onSubmit={handleSubmit} className="space-y-6 max-w-lg">
//             {activeService.fields.map((field) => (
//               <div key={field.name} className="flex flex-col">
//                 <label className="text-sm font-semibold text-[#12345A] mb-2">
//                   {field.label}
//                 </label>
//                 <input
//                   type="text"
//                   name={field.name}
//                   value={formData[field.name] || ""}
//                   onChange={handleInputChange}
//                   placeholder={field.placeholder}
//                   required
//                   className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#12345A] focus:border-transparent transition-all"
//                 />
//               </div>
//             ))}

//             {activeService.note && (
//               <div className={`p-3 rounded-lg text-sm font-medium ${activeTab === 'benePennyDrop' ? 'bg-red-50 text-red-700 border border-red-200' : 'bg-blue-50 text-blue-700 border border-blue-200'}`}>
//                 {activeService.note}
//               </div>
//             )}

//             <button
//               type="submit"
//               disabled={activeService.loading}
//               className="w-full bg-[#12345A] text-white font-bold py-3 px-4 rounded-lg hover:bg-[#0d2644] transition-all disabled:opacity-70 disabled:cursor-not-allowed flex justify-center items-center"
//             >
//               {activeService.loading ? (
//                 <span className="animate-pulse flex items-center">
//                   <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                   </svg>
//                   Verifying...
//                 </span>
//               ) : (
//                 "Verify Now"
//               )}
//             </button>
//           </form>

//           {/* ERROR DISPLAY */}
//           {errorMsg && (
//             <div className="mt-8 p-4 bg-red-50 border-l-4 border-red-500 rounded-r-lg shadow-sm">
//               <div className="flex items-center">
//                 <svg className="w-6 h-6 text-red-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
//                 </svg>
//                 <h4 className="text-lg font-bold text-red-800">Verification Failed</h4>
//               </div>
//               <p className="mt-2 text-red-700 font-medium ml-8">{errorMsg}</p>
//             </div>
//           )}

//           {/* CLEAN RESULTS DISPLAY */}
//           {renderCleanResults()}

//         </div>
//       </div>
//     </div>
//   );
// };

// export default Verification;

// this is old working code for 6 apis 

// import React, { useState } from "react";
// import { useSelector } from "react-redux";
// import useApi from "../../CustomHooks/useApi";

// const Verification = () => {
//   const userId = useSelector((state) => state.auth.employeeDetails?.userId);
  
//   // Added selector for merchant details to pick up the username
//   const merchantdetails = useSelector((state) => state.auth?.employeeDetails);
//   const username = merchantdetails?.username || ""; // Safely extract username

//   const { callApi: verifyPan, loading: loadingPan } = useApi("/kyc/verify/pan", "POST");
//   const { callApi: verifyAadhaar, loading: loadingAadhaar } = useApi("/kyc/verify/aadhaar", "POST");
//   const { callApi: verifyPanAadhaarLink, loading: loadingLink } = useApi("/kyc/verify/pan-aadhaar-link", "POST");
//   const { callApi: verifyBenePennyless, loading: loadingPennyless } = useApi("/kyc/verify/bene/pennyless", "POST");
//   const { callApi: verifyBenePennyDrop, loading: loadingPennyDrop } = useApi("/kyc/verify/bene/penny-drop", "POST");
//   const { callApi: verifyMobileToUpi, loading: loadingMobile } = useApi("/kyc/verify/mobile-to-upi", "POST");
//   const { callApi: verifyUpi, loading: loadingUpi } = useApi("/kyc/verify/upi", "POST");

//   const [activeTab, setActiveTab] = useState("pan");
//   const [formData, setFormData] = useState({});
//   const [resultData, setResultData] = useState(null);
//   const [errorMsg, setErrorMsg] = useState("");

//   const servicesConfig = {
//     pan: {
//       title: "PAN Verification",
//       fields: [{ name: "panNumber", label: "PAN Number", placeholder: "e.g. AAICP3293R" }],
//       apiCall: verifyPan,
//       loading: loadingPan,

//       note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
//     },
//     // aadhaar: {
//     //   title: "Aadhaar Verification",
//     //   fields: [{ name: "aadhaarNumber", label: "Aadhaar Number", placeholder: "12-digit number" }],
//     //   apiCall: verifyAadhaar,
//     //   loading: loadingAadhaar,
//     // },
//     panAadhaar: {
//       title: "PAN-Aadhaar Link Check",
//       fields: [
//         { name: "pan", label: "PAN Number", placeholder: "e.g. GDCPS0678M" },
//         { name: "aadhaar", label: "Aadhaar Number", placeholder: "12-digit number" },
//       ],
//       apiCall: verifyPanAadhaarLink,
//       loading: loadingLink,

//       note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
//     },
//     benePennyless: {
//       title: "Beneficiary (Penny-Less)",
//       fields: [
//         { name: "accountNumber", label: "Account Number", placeholder: "e.g. 1234567890" },
//         { name: "ifsc", label: "IFSC Code", placeholder: "e.g. HDFC0001234" },
//       ],
//       apiCall: verifyBenePennyless,
//       loading: loadingPennyless,

//       note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
//     },
//     benePennyDrop: {
//       title: "Beneficiary (Penny Drop)",
//       fields: [
//         { name: "accountNumber", label: "Account Number", placeholder: "e.g. 1234567890" },
//         { name: "ifsc", label: "IFSC Code", placeholder: "e.g. HDFC0001234" },
//       ],
//       apiCall: verifyBenePennyDrop,
//       loading: loadingPennyDrop,
//       note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
//     },
//     mobileUpi: {
//       title: "Mobile to UPI Lookup",
//       fields: [{ name: "mobileNumber", label: "Mobile Number", placeholder: "10-digit number" }],
//       apiCall: verifyMobileToUpi,
//       loading: loadingMobile,

//       note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
//     },
//     upi: {
//       title: "UPI ID Verification",
//       fields: [{ name: "upiId", label: "UPI ID", placeholder: "e.g. 8376060847@upi" }],
//       apiCall: verifyUpi,
//       loading: loadingUpi,

//       note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
//     },
//   };

//   const handleInputChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleTabSwitch = (key) => {
//     setActiveTab(key);
//     setFormData({});
//     setResultData(null);
//     setErrorMsg("");
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setResultData(null);
//     setErrorMsg("");

//     const activeService = servicesConfig[activeTab];
    
//     try {
//       // Merging formData with the username from Redux before creating the query string
//       const payload = { ...formData };
//       if (username) {
//         payload.username = username;
//       }
      
//       const queryString = new URLSearchParams(payload).toString();
//       const response = await activeService.apiCall(null, `?${queryString}`);
      
//       // Handle logical API errors (like your 202 Pennydrop error)
//       if (response?.error || response?.error_code || response?.status === "failed") {
//         setErrorMsg(response.message || response.error || "Verification failed.");
//         return;
//       }

//       // Handle standard successes
//       if (response && (response.status === "success" || response.status_code === 200)) {
//         setResultData(response);
//       } else {
//         setErrorMsg("Unexpected response format received from server.");
//       }
//     } catch (err) {
//       setErrorMsg(err.message || "An error occurred during verification.");
//     }
//   };

//   const activeService = servicesConfig[activeTab];

//   // --- UI HELPER COMPONENTS --- //
//   const ResultCard = ({ label, value, isBoolean }) => (
//     <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 flex flex-col">
//       <span className="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-1">
//         {label}
//       </span>
//       {isBoolean ? (
//         <span className={`font-bold ${value ? 'text-green-600' : 'text-red-600'}`}>
//           {value ? "✓ Yes / Verified" : "✗ No / Unverified"}
//         </span>
//       ) : (
//         <span className="text-[#12345A] font-semibold text-lg capitalize">
//           {value || "N/A"}
//         </span>
//       )}
//     </div>
//   );

//   const renderCleanResults = () => {
//     if (!resultData) return null;

//     // Handle APIs that wrap data in a "data" object vs flat structure
//     const data = resultData.data || resultData; 

//     return (
//       <div className="mt-8 border border-green-200 rounded-xl overflow-hidden shadow-sm bg-white">
//         <div className="bg-green-50 border-b border-green-200 px-6 py-4 flex items-center">
//           <svg className="w-6 h-6 text-green-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
//           </svg>
//           <h4 className="text-lg font-bold text-green-800">Verification Successful</h4>
//         </div>
        
//         <div className="p-6">
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            
//             {/* PAN RESULTS */}
//             {activeTab === 'pan' && (
//               <>
//                 <ResultCard label="Registered Name" value={data.fullName} />
//                 <ResultCard label="PAN Number" value={data.panNumber} />
//                 <ResultCard label="Category" value={data.category} />
//               </>
//             )}

//             {/* PAN-AADHAAR LINK RESULTS */}
//             {activeTab === 'panAadhaar' && (
//               <>
//                 <ResultCard label="Link Status" value={data.is_linked} isBoolean={true} />
//                 <ResultCard label="System Message" value={data.message} />
//                 <ResultCard label="PAN Checked" value={data.pan_number} />
//               </>
//             )}

//             {/* BENEFICIARY (PENNYLESS & PENNYDROP) RESULTS */}
//             {(activeTab === 'benePennyless' || activeTab === 'benePennyDrop') && (
//               <>
//                 <ResultCard label="Account Holder Name" value={data.full_name || data.fullName} />
//                 <ResultCard label="Account Exists" value={data.account_exists || data.accountExists} isBoolean={true} />
//                 {data.txnRefId && <ResultCard label="Transaction Ref ID" value={data.txnRefId} />}
//               </>
//             )}

//             {/* MOBILE TO UPI RESULTS */}
//             {activeTab === 'mobileUpi' && (
//               <>
//                 <ResultCard label="Registered Name" value={data.name} />
//                 <ResultCard label="UPI ID" value={data.upi_id || data.upiId} />
//               </>
//             )}

//             {/* UPI ID RESULTS */}
//             {activeTab === 'upi' && (
//               <>
//                 <ResultCard label="Name at Bank" value={data.name_at_bank || data.nameAtBank} />
//                 <ResultCard label="Account Status" value={data.account_exists || data.accountExists} isBoolean={true} />
//               </>
//             )}

//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-6 font-sans">
//       <div className="max-w-6xl mx-auto bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden flex flex-col md:flex-row">
        
//         {/* SIDEBAR TABS */}
//         <div className="w-full md:w-1/3 bg-[#12345A] text-white flex flex-col">
//           <div className="p-6 border-b border-[#1c4d85]">
//             <h2 className="text-2xl font-bold tracking-wide">Verification Hub</h2>
//             <p className="text-sm text-gray-300 mt-1">Select a service to verify identity</p>
//           </div>
//           <div className="flex-1 overflow-y-auto p-4 space-y-2">
//             {Object.entries(servicesConfig).map(([key, config]) => (
//               <button
//                 key={key}
//                 onClick={() => handleTabSwitch(key)}
//                 className={`w-full text-left px-4 py-3 rounded-lg transition-all duration-300 font-medium ${
//                   activeTab === key
//                     ? "bg-white text-[#12345A] shadow-md"
//                     : "text-gray-300 hover:bg-[#1c4d85] hover:text-white"
//                 }`}
//               >
//                 {config.title}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* MAIN CONTENT AREA */}
//         <div className="w-full md:w-2/3 p-8">
//           <h3 className="text-3xl font-bold text-[#12345A] mb-6 border-b pb-4">
//             {activeService.title}
//           </h3>

//           {/* DYNAMIC FORM */}
//           <form onSubmit={handleSubmit} className="space-y-6 max-w-lg">
//             {activeService.fields.map((field) => (
//               <div key={field.name} className="flex flex-col">
//                 <label className="text-sm font-semibold text-[#12345A] mb-2">
//                   {field.label}
//                 </label>
//                 <input
//                   type="text"
//                   name={field.name}
//                   value={formData[field.name] || ""}
//                   onChange={handleInputChange}
//                   placeholder={field.placeholder}
//                   required
//                   className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#12345A] focus:border-transparent transition-all"
//                 />
//               </div>
//             ))}

//             {activeService.note && (
//               <div className={`p-3 rounded-lg text-sm font-medium ${activeTab === 'benePennyDrop' ? 'bg-red-50 text-red-700 border border-red-200' : 'bg-blue-50 text-blue-700 border border-blue-200'}`}>
//                 {activeService.note}
//               </div>
//             )}

//             <button
//               type="submit"
//               disabled={activeService.loading}
//               className="w-full bg-[#12345A] text-white font-bold py-3 px-4 rounded-lg hover:bg-[#0d2644] transition-all disabled:opacity-70 disabled:cursor-not-allowed flex justify-center items-center"
//             >
//               {activeService.loading ? (
//                 <span className="animate-pulse flex items-center">
//                   <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                   </svg>
//                   Verifying...
//                 </span>
//               ) : (
//                 "Verify Now"
//               )}
//             </button>
//           </form>

//           {/* ERROR DISPLAY */}
//           {errorMsg && (
//             <div className="mt-8 p-4 bg-red-50 border-l-4 border-red-500 rounded-r-lg shadow-sm">
//               <div className="flex items-center">
//                 <svg className="w-6 h-6 text-red-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
//                 </svg>
//                 <h4 className="text-lg font-bold text-red-800">Verification Failed</h4>
//               </div>
//               <p className="mt-2 text-red-700 font-medium ml-8">{errorMsg}</p>
//             </div>
//           )}

//           {/* CLEAN RESULTS DISPLAY */}
//           {renderCleanResults()}

//         </div>
//       </div>
//     </div>
//   );
// };

// export default Verification;





// new one but in this cin and all are not linked properly 
// import React, { useState } from "react";
// import { useSelector } from "react-redux";
// import useApi from "../../CustomHooks/useApi";

// const Verification = () => {
//   const userId = useSelector((state) => state.auth.employeeDetails?.userId);
//   const merchantdetails = useSelector((state) => state.auth?.employeeDetails);
//   const username = merchantdetails?.username || "";

//   /* ================= HOOKS: ORIGINAL APIS ================= */
//   const { callApi: verifyPan, loading: loadingPan } = useApi("/kyc/verify/pan", "POST");
//   const { callApi: verifyPanAadhaarLink, loading: loadingLink } = useApi("/kyc/verify/pan-aadhaar-link", "POST");
//   const { callApi: verifyBenePennyless, loading: loadingPennyless } = useApi("/kyc/verify/bene/pennyless", "POST");
//   const { callApi: verifyBenePennyDrop, loading: loadingPennyDrop } = useApi("/kyc/verify/bene/penny-drop", "POST");
//   const { callApi: verifyMobileToUpi, loading: loadingMobile } = useApi("/kyc/verify/mobile-to-upi", "POST");
//   const { callApi: verifyUpi, loading: loadingUpi } = useApi("/kyc/verify/upi", "POST");

//   /* ================= HOOKS: NEW QUICK-EKYC APIS ================= */
//   const { callApi: apiAadhaarMobileLink, loading: loadingAadhMobile } = useApi("/quick-ekyc/aadhaar/mobile-link", "POST");
//   const { callApi: apiVoterIdVerify, loading: loadingVoter } = useApi("/quick-ekyc/voter-id/verify", "POST");
//   const { callApi: apiMaskedPanVerify, loading: loadingMaskedPan } = useApi("/quick-ekyc/pan/masked-verify", "POST");
//   const { callApi: apiRationCardVerify, loading: loadingRation } = useApi("/quick-ekyc/ration-card/verify", "POST");
//   const { callApi: apiDrivingLicenseVerify, loading: loadingDl } = useApi("/quick-ekyc/driving-license/verify", "POST");
//   const { callApi: apiPanAadhaarLinked, loading: loadingPanLinked } = useApi("/quick-ekyc/pan/linked", "POST");
  
//   // -- NEWLY ADDED APIS --
//   const { callApi: apiPanValidation, loading: loadingPanVal } = useApi("/quick-ekyc/pan/validate", "POST");
//   const { callApi: apiAadhaarToPan, loading: loadingAadhaarPan } = useApi("/quick-ekyc/aadhaar/to-pan", "POST");
//   const { callApi: apiMobileUpiAdvance, loading: loadingMobileUpiAdv } = useApi("/quick-ekyc/mobile/to-upi-advance", "POST");
//   const { callApi: apiChallanVerify, loading: loadingChallan } = useApi("/quick-ekyc/vehicle/challan", "POST");
//   const { callApi: apiUdyogAadhaar, loading: loadingUdyog } = useApi("/quick-ekyc/business/udyog-aadhaar", "POST");
//   const { callApi: apiDinVerify, loading: loadingDin } = useApi("/quick-ekyc/business/din", "POST");
//   const { callApi: apiCinVerify, loading: loadingCin } = useApi("/quick-ekyc/business/cin", "POST");
//   const { callApi: apiGstinVerify, loading: loadingGstin } = useApi("/quick-ekyc/business/gstin", "POST");

//   const [activeTab, setActiveTab] = useState("pan");
//   const [formData, setFormData] = useState({});
//   const [resultData, setResultData] = useState(null);
//   const [errorMsg, setErrorMsg] = useState("");

//   const servicesConfig = {
//     /* ----- ORIGINAL FEATURES ----- */
//     pan: {
//       title: "PAN Verification",
//       fields: [{ name: "panNumber", label: "PAN Number", placeholder: "e.g. AAICP3293R" }],
//       apiCall: verifyPan,
//       loading: loadingPan,
//       note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
//     },
//     panAadhaar: {
//       title: "PAN-Aadhaar Link Check",
//       fields: [
//         { name: "pan", label: "PAN Number", placeholder: "e.g. GDCPS0678M" },
//         { name: "aadhaar", label: "Aadhaar Number", placeholder: "12-digit number" },
//       ],
//       apiCall: verifyPanAadhaarLink,
//       loading: loadingLink,
//       note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
//     },
//     benePennyless: {
//       title: "Beneficiary (Penny-Less)",
//       fields: [
//         { name: "accountNumber", label: "Account Number", placeholder: "e.g. 1234567890" },
//         { name: "ifsc", label: "IFSC Code", placeholder: "e.g. HDFC0001234" },
//       ],
//       apiCall: verifyBenePennyless,
//       loading: loadingPennyless,
//       note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
//     },
//     benePennyDrop: {
//       title: "Beneficiary (Penny Drop)",
//       fields: [
//         { name: "accountNumber", label: "Account Number", placeholder: "e.g. 1234567890" },
//         { name: "ifsc", label: "IFSC Code", placeholder: "e.g. HDFC0001234" },
//       ],
//       apiCall: verifyBenePennyDrop,
//       loading: loadingPennyDrop,
//       note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
//     },
//     mobileUpi: {
//       title: "Mobile to UPI Lookup",
//       fields: [{ name: "mobileNumber", label: "Mobile Number", placeholder: "10-digit number" }],
//       apiCall: verifyMobileToUpi,
//       loading: loadingMobile,
//       note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
//     },
//     upi: {
//       title: "UPI ID Verification",
//       fields: [{ name: "upiId", label: "UPI ID", placeholder: "e.g. username@upi" }],
//       apiCall: verifyUpi,
//       loading: loadingUpi,
//       note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
//     },

//     /* ----- APPENDED NEW QUICK-EKYC FEATURES ----- */
//     aadhaarMobileLink: {
//       title: "Aadhaar Mobile Link Check",
//       fields: [{ name: "aadhaarNumber", label: "Aadhaar Number", placeholder: "Enter 12-digit Number" }],
//       apiCall: apiAadhaarMobileLink,
//       loading: loadingAadhMobile,
//       note: "⚡ Quick eKYC verification hub service.",
//     },
//     voterIdVerify: {
//       title: "Voter ID Verification",
//       fields: [{ name: "voterIdNumber", label: "Voter ID / EPIC Number", placeholder: "e.g. ABC1234567" }],
//       apiCall: apiVoterIdVerify,
//       loading: loadingVoter,
//       note: "⚡ Quick eKYC verification hub service.",
//     },
//     maskedPanVerify: {
//       title: "Masked PAN Verification",
//       fields: [{ name: "panNumber", label: "PAN Number", placeholder: "e.g. ABCDE1234F" }],
//       apiCall: apiMaskedPanVerify,
//       loading: loadingMaskedPan,
//       note: "⚡ Quick eKYC verification hub service.",
//     },
//     rationCardVerify: {
//       title: "Ration Card Verification",
//       fields: [{ name: "rationCardNumber", label: "Ration Card Number", placeholder: "Enter Ration Card No." }],
//       apiCall: apiRationCardVerify,
//       loading: loadingRation,
//       note: "⚡ Quick eKYC verification hub service.",
//     },
//     drivingLicenseVerify: {
//       title: "Driving License Verification",
//       fields: [
//         { name: "licenseNumber", label: "Driving License Number", placeholder: "e.g. HR0120230012345" },
//         { name: "dob", label: "Date of Birth", placeholder: "YYYY-MM-DD", type: "date" }
//       ],
//       apiCall: apiDrivingLicenseVerify,
//       loading: loadingDl,
//       note: "⚡ Quick eKYC verification hub service.",
//     },
//     panLinkedCheck: {
//       title: "PAN Aadhaar Link State",
//       fields: [{ name: "panNumber", label: "PAN Number", placeholder: "e.g. ABCDE1234F" }],
//       apiCall: apiPanAadhaarLinked,
//       loading: loadingPanLinked,
//       note: "⚡ Quick eKYC verification hub service.",
//     },

//     /* ----- NEW FEATURES ADDED TODAY ----- */
//     panValidation: {
//       title: "PAN Validation Check",
//       fields: [{ name: "panNumber", label: "PAN Number", placeholder: "e.g. ABCDE1234F" }],
//       apiCall: apiPanValidation,
//       loading: loadingPanVal,
//       note: "⚡ Validates PAN details and categorization.",
//     },
//     aadhaarToPan: {
//       title: "Aadhaar to PAN Lookup",
//       fields: [{ name: "aadhaarNumber", label: "Aadhaar Number", placeholder: "Enter 12-digit Number" }],
//       apiCall: apiAadhaarToPan,
//       loading: loadingAadhaarPan,
//       note: "⚡ Fetch linked PAN details directly from an Aadhaar Number.",
//     },
//     mobileUpiAdvance: {
//       title: "Mobile to UPI Advance",
//       fields: [{ name: "mobileNumber", label: "Mobile Number", placeholder: "10-digit number" }],
//       apiCall: apiMobileUpiAdvance,
//       loading: loadingMobileUpiAdv,
//       note: "⚡ Retrieves multiple linked UPI IDs across banks.",
//     },
//     challanVerify: {
//       title: "Challan Verify",
//       fields: [{ name: "rcNumber", label: "RC Number", placeholder: "e.g. HRXXXX1234" }],
//       apiCall: apiChallanVerify,
//       loading: loadingChallan,
//       note: "⚡ Verification of Vehicle/Traffic Challans.",
//     },
//     udyogAadhaar: {
//       title: "Udyog Aadhaar (MSME)",
//       fields: [{ name: "uanNumber", label: "Udyog Aadhaar Number", placeholder: "e.g. HR0123456789" }],
//       apiCall: apiUdyogAadhaar,
//       loading: loadingUdyog,
//       note: "⚡ Verify MSME registration details.",
//     },
//     dinVerify: {
//       title: "DIN Verification",
//       fields: [{ name: "dinNumber", label: "DIN Number", placeholder: "Enter 8-digit DIN" }],
//       apiCall: apiDinVerify,
//       loading: loadingDin,
//       note: "⚡ Director Identification Number Lookup.",
//     },
//     cinVerify: {
//       title: "CIN / Company Details",
//       fields: [{ name: "cinNumber", label: "CIN Number", placeholder: "e.g. U12345HR2015PTC..." }],
//       apiCall: apiCinVerify,
//       loading: loadingCin,
//       note: "⚡ Verify Corporate Identity Number (CIN).",
//     },
//     gstinVerify: {
//       title: "GSTIN Verify",
//       fields: [{ name: "gstinNumber", label: "GSTIN Number", placeholder: "e.g. 29ABCDE1234F1Z5" }],
//       apiCall: apiGstinVerify,
//       loading: loadingGstin,
//       note: "⚡ Verify Goods and Services Tax Identification Number.",
//     },
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     const uppercaseFields = [
//       "panNumber", "pan", "ifsc", "voterIdNumber", "licenseNumber", 
//       "rcNumber", "udyogAadhaarNumber", "dinNumber", "cinNumber", "gstinNumber"
//     ];
//     const finalValue = uppercaseFields.includes(name) ? value.toUpperCase() : value;

//     setFormData({ ...formData, [name]: finalValue });
//   };

//   const handleTabSwitch = (key) => {
//     setActiveTab(key);
//     setFormData({});
//     setResultData(null);
//     setErrorMsg("");
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setResultData(null);
//     setErrorMsg("");

//     const activeService = servicesConfig[activeTab];
    
//     try {
//       const payload = { ...formData };
//       if (username) {
//         payload.username = username;
//       }
      
//       const queryString = new URLSearchParams(payload).toString();
//       const response = await activeService.apiCall(null, `?${queryString}`);
      
//       if (response?.error || response?.error_code || response?.status === "error" || response?.status === "failed") {
//         setErrorMsg(response.message || response.error || "Verification failed.");
//         return;
//       }

//       if (response && (response.status === "success" || response.status_code === 200)) {
//         setResultData(response);
//       } else {
//         setErrorMsg("Unexpected response format received from server.");
//       }
//     } catch (err) {
//       setErrorMsg(err.message || "An error occurred during verification.");
//     }
//   };

//   const activeService = servicesConfig[activeTab];

//   const ResultCard = ({ label, value, isBoolean }) => (
//     <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 flex flex-col">
//       <span className="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-1">
//         {label}
//       </span>
//       {isBoolean ? (
//         <span className={`font-bold ${value ? 'text-green-600' : 'text-red-600'}`}>
//           {value ? "✓ Yes / Verified" : "✗ No / Unverified"}
//         </span>
//       ) : (
//         <span className="text-[#12345A] font-semibold text-sm sm:text-base break-words">
//           {value || "N/A"}
//         </span>
//       )}
//     </div>
//   );

//   const renderCleanResults = () => {
//     if (!resultData) return null;
//     const data = resultData.data || resultData; 

//     return (
//       <div className="mt-8 border border-green-200 rounded-xl overflow-hidden shadow-sm bg-white">
//         <div className="bg-green-50 border-b border-green-200 px-6 py-4 flex items-center">
//           <svg className="w-6 h-6 text-green-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
//           </svg>
//           <h4 className="text-lg font-bold text-green-800">Verification Successful</h4>
//         </div>
        
//         <div className="p-6">
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            
//             {/* ORIGINAL PAN RESULTS */}
//             {activeTab === 'pan' && (
//               <>
//                 <ResultCard label="Registered Name" value={data.fullName} />
//                 <ResultCard label="PAN Number" value={data.panNumber} />
//                 <ResultCard label="Category" value={data.category} />
//               </>
//             )}

//             {/* ORIGINAL PAN-AADHAAR LINK RESULTS */}
//             {activeTab === 'panAadhaar' && (
//               <>
//                 <ResultCard label="Link Status" value={data.is_linked} isBoolean={true} />
//                 <ResultCard label="System Message" value={data.message} />
//                 <ResultCard label="PAN Checked" value={data.pan_number} />
//               </>
//             )}

//             {/* ORIGINAL BENEFICIARY RESULTS */}
//             {(activeTab === 'benePennyless' || activeTab === 'benePennyDrop') && (
//               <>
//                 <ResultCard label="Account Holder Name" value={data.full_name || data.fullName} />
//                 <ResultCard label="Account Exists" value={data.account_exists || data.accountExists} isBoolean={true} />
//                 {data.txnRefId && <ResultCard label="Transaction Ref ID" value={data.txnRefId} />}
//               </>
//             )}

//             {/* ORIGINAL MOBILE TO UPI RESULTS */}
//             {activeTab === 'mobileUpi' && (
//               <>
//                 <ResultCard label="Registered Name" value={data.name} />
//                 <ResultCard label="UPI ID" value={data.upi_id || data.upiId} />
//               </>
//             )}

//             {/* ORIGINAL UPI ID RESULTS */}
//             {activeTab === 'upi' && (
//               <>
//                 <ResultCard label="Name at Bank" value={data.name_at_bank || data.nameAtBank} />
//                 <ResultCard label="Account Status" value={data.account_exists || data.accountExists} isBoolean={true} />
//               </>
//             )}

//             {/* AADHAAR MOBILE LINK RESULTS */}
//             {activeTab === 'aadhaarMobileLink' && (
//               <>
//                 <ResultCard label="Aadhaar Reference" value={formData.aadhaarNumber} />
//                 <ResultCard label="Linked Mobile" value={data.mobile_number} />
//               </>
//             )}

//             {/* VOTER ID VERIFY RESULTS */}
//             {activeTab === 'voterIdVerify' && (
//               <>
//                 <ResultCard label="EPIC Number" value={data.epic_no} />
//                 <ResultCard label="Full Name" value={data.name} />
//                 <ResultCard label="Gender Check" value={data.gender} />
//                 <ResultCard label="Date of Birth" value={data.dob} />
//                 <ResultCard label="Age Indicator" value={data.age} />
//                 <ResultCard label="State Region" value={data.state} />
//                 <ResultCard label="District Location" value={data.district} />
//                 <ResultCard label="Area / Ward Details" value={data.area} />
//                 <ResultCard label="House Number" value={data.house_no} />
//                 <ResultCard label="Relative Associated" value={data.relation_name} />
//                 <ResultCard label="Relation Type Indicator" value={data.relation_type} />
//                 <ResultCard label="Assembly Constituency" value={data.assembly_constituency} />
//                 <ResultCard label="Polling Station Base" value={data.polling_station} />
//               </>
//             )}

//             {/* MASKED PAN VERIFY RESULTS */}
//             {activeTab === 'maskedPanVerify' && (
//               <>
//                 <ResultCard label="PAN String Check" value={data.pan_number} />
//                 <ResultCard label="First Name Profile" value={data.first_name} />
//                 <ResultCard label="Middle Name Profile" value={data.middle_name} />
//                 <ResultCard label="Last Name Profile" value={data.last_name} />
//                 <ResultCard label="Birth Date Reference" value={data.dob} />
//                 <ResultCard label="Gender Code" value={data.gender} />
//               </>
//             )}

//             {/* RATION CARD VERIFY RESULTS */}
//             {activeTab === 'rationCardVerify' && (
//               <>
//                 <ResultCard label="Ration Card Identifier" value={data.ration_card_no} />
//                 <ResultCard label="State Base" value={data.state} />
//                 <ResultCard label="District Base" value={data.district} />
//                 <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 flex flex-col col-span-1 sm:col-span-2">
//                   <span className="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-2">
//                     Family Members List
//                   </span>
//                   <div className="space-y-1 divide-y divide-gray-200">
//                     {data.members?.map((m) => (
//                       <div key={m.member_id} className="pt-1.5 flex justify-between text-sm text-gray-700 font-medium">
//                         <span>{m.member_name}</span>
//                         <span className="text-indigo-600 text-xs font-bold uppercase tracking-wider">({m.relationship})</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </>
//             )}

//             {/* DRIVING LICENSE VERIFY RESULTS */}
//             {activeTab === 'drivingLicenseVerify' && (
//               <>
//                 <ResultCard label="License ID String" value={data.license_number} />
//                 <ResultCard label="Holder Name" value={data.name} />
//                 <ResultCard label="Father / Husband Name" value={data.father_or_husband_name} />
//                 <ResultCard label="Gender Check" value={data.gender} />
//                 <ResultCard label="Birth Date Check" value={data.dob} />
//                 <ResultCard label="Issue Date (DOI)" value={data.doi} />
//                 <ResultCard label="Expiry Date (DOE)" value={data.doe} />
//                 <ResultCard label="State Location" value={data.state} />
//                 <ResultCard label="Permanent Address" value={data.permanent_address} />
//                 <ResultCard label="Postal ZIP Code" value={data.permanent_zip} />
//                 <ResultCard label="Blood Group Category" value={data.blood_group} />
//                 <ResultCard label="Vehicle Permitted Classes" value={data.vehicle_classes?.join(", ")} />
//               </>
//             )}

//             {/* PAN LINKED (AADHAAR LINKAGE) RESULTS */}
//             {activeTab === 'panLinkedCheck' && (
//               <>
//                 <ResultCard label="Link Status Verified" value={data.is_linked} isBoolean={true} />
//               </>
//             )}

//             {/* ---------------- NEW RENDER BLOCKS ---------------- */}
            
//             {/* PAN VALIDATION */}
//             {activeTab === 'panValidation' && (
//               <>
//                 <ResultCard label="PAN Number" value={data.pan_number} />
//                 <ResultCard label="PAN Validation Status" value={data.valid} isBoolean={true} />
//                 <ResultCard label="Holder Name" value={data.name} />
//                 <ResultCard label="PAN Type" value={data.pan_type} />
//                 <ResultCard label="Category" value={data.category} />
//               </>
//             )}

//             {/* AADHAAR TO PAN */}
//             {activeTab === 'aadhaarToPan' && (
//               <>
//                 <ResultCard label="Linked PAN Number" value={data.pan_number} />
//                 <ResultCard label="Holder Name" value={data.name} />
//                 <ResultCard label="Date of Birth" value={data.dob} />
//                 <ResultCard label="Gender" value={data.gender} />
//               </>
//             )}

//             {/* MOBILE TO UPI ADVANCE */}
//             {activeTab === 'mobileUpiAdvance' && (
//               <>
//                 <ResultCard label="Mobile Number" value={data.mobile_number} />
//                 <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 flex flex-col col-span-1 sm:col-span-2">
//                   <span className="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-2">
//                     UPI Accounts Associated
//                   </span>
//                   <div className="space-y-3 divide-y divide-gray-200">
//                     {data.upi_list?.length > 0 ? data.upi_list.map((upi, i) => (
//                       <div key={i} className="pt-3 flex flex-col sm:flex-row sm:justify-between sm:items-center text-sm text-gray-700">
//                         <span className="font-bold text-indigo-600">{upi.upi_id}</span>
//                         <span className="font-medium mt-1 sm:mt-0">{upi.name}</span>
//                         <span className="text-gray-500 text-xs uppercase tracking-wide mt-1 sm:mt-0">{upi.bank}</span>
//                       </div>
//                     )) : (
//                       <div className="pt-2 text-sm text-gray-500">No UPI records found.</div>
//                     )}
//                   </div>
//                 </div>
//               </>
//             )}

//             {/* CHALLAN VERIFY */}
//             {activeTab === 'challanVerify' && (
//               <>
//                 <ResultCard label="Challan Number" value={data.challan_number} />
//                 <ResultCard label="Vehicle Number" value={data.vehicle_number} />
//                 <ResultCard label="Owner Name" value={data.owner_name} />
//                 <ResultCard label="Challan Status" value={data.challan_status} />
//                 <ResultCard label="Challan Amount" value={data.challan_amount ? `₹${data.challan_amount}` : "N/A"} />
//                 <ResultCard label="Fine Imposed Date" value={data.fine_imposed} />
//                 <ResultCard label="Offence" value={data.offence} />
//                 <ResultCard label="State" value={data.state} />
//               </>
//             )}

//             {/* UDYOG AADHAAR */}
//             {activeTab === 'udyogAadhaar' && (
//               <>
//                 <ResultCard label="Udyog Aadhaar Number" value={data.udyog_aadhaar_number} />
//                 <ResultCard label="Enterprise Name" value={data.enterprise_name} />
//                 <ResultCard label="Owner Name" value={data.owner_name} />
//                 <ResultCard label="Category" value={data.category} />
//                 <ResultCard label="Type" value={data.type} />
//                 <ResultCard label="NIC 2-Digit Code" value={data.nic_2_digit_code} />
//                 <ResultCard label="Major Activity" value={data.major_activity} />
//                 <ResultCard label="Commencement Date" value={data.date_of_commencement} />
//                 <ResultCard label="State" value={data.state} />
//                 <ResultCard label="District" value={data.district} />
//                 <ResultCard label="PIN Code" value={data.pin_code} />
//                 <ResultCard label="Bank Name" value={data.bank_name} />
//                 <ResultCard label="Bank IFSC" value={data.bank_ifsc} />
//                 <ResultCard label="Bank Account" value={data.bank_account} />
//               </>
//             )}

//             {/* DIN VERIFY */}
//             {activeTab === 'dinVerify' && (
//               <>
//                 <ResultCard label="DIN" value={data.din} />
//                 <ResultCard label="Director Name" value={data.name} />
//                 <ResultCard label="Status" value={data.status} />
//                 <ResultCard label="Designation" value={data.designation} />
//                 <ResultCard label="Company Name" value={data.company_name} />
//                 <ResultCard label="Company CIN" value={data.company_cin} />
//                 <ResultCard label="Date of Appointment" value={data.date_of_appointment} />
//                 <ResultCard label="PAN Associated" value={data.pan} />
//               </>
//             )}

//             {/* CIN VERIFY */}
//             {activeTab === 'cinVerify' && (
//               <>
//                 <ResultCard label="CIN" value={data.cin} />
//                 <ResultCard label="Company Name" value={data.company_name} />
//                 <ResultCard label="Company Status" value={data.company_status} />
//                 <ResultCard label="Company Type" value={data.company_type} />
//                 <ResultCard label="Company Category" value={data.company_category} />
//                 <ResultCard label="Sub Category" value={data.company_sub_category} />
//                 <ResultCard label="Date of Incorporation" value={data.date_of_incorporation} />
//                 <ResultCard label="Email" value={data.email} />
//                 <ResultCard label="Authorised Capital" value={data.authorised_capital ? `₹${data.authorised_capital.toLocaleString()}` : "N/A"} />
//                 <ResultCard label="Paid Up Capital" value={data.paid_up_capital ? `₹${data.paid_up_capital.toLocaleString()}` : "N/A"} />
//                 <ResultCard label="State" value={data.state} />
//                 <ResultCard label="Registered Address" value={data.registered_address} />
                
//                 {data.directors && data.directors.length > 0 && (
//                   <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 flex flex-col col-span-1 sm:col-span-2">
//                     <span className="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-2">Company Directors</span>
//                     <div className="space-y-1 divide-y divide-gray-200">
//                       {data.directors.map((d, i) => (
//                         <div key={i} className="pt-2 pb-1 flex flex-col sm:flex-row justify-between text-sm text-gray-700">
//                           <span className="font-semibold">{d.name}</span>
//                           <span className="text-indigo-600 mt-1 sm:mt-0">{d.designation} <span className="text-xs text-gray-500 uppercase">(DIN: {d.din})</span></span>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </>
//             )}

//             {/* GSTIN VERIFY */}
//             {activeTab === 'gstinVerify' && (
//               <>
//                 <ResultCard label="GSTIN" value={data.gstin} />
//                 <ResultCard label="Legal Name" value={data.legal_name} />
//                 <ResultCard label="Trade Name" value={data.trade_name} />
//                 <ResultCard label="GSTIN Status" value={data.gstin_status} />
//                 <ResultCard label="Taxpayer Type" value={data.taxpayer_type} />
//                 <ResultCard label="Constitution of Business" value={data.constitution_of_business} />
//                 <ResultCard label="Registration Date" value={data.registration_date} />
//                 <ResultCard label="Cancellation Date" value={data.cancellation_date || "N/A"} />
//                 <ResultCard label="State Jurisdiction" value={data.state_jurisdiction} />
//                 <ResultCard label="Centre Jurisdiction" value={data.centre_jurisdiction} />
//                 <ResultCard label="Nature of Business" value={data.nature_of_business?.join(", ") || "N/A"} />
//                 <ResultCard label="Registered Address" value={data.registered_address} />
                
//                 {data.filing_status && data.filing_status.length > 0 && (
//                   <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 flex flex-col col-span-1 sm:col-span-2">
//                     <span className="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-2">GST Filing Status</span>
//                     <div className="space-y-2 divide-y divide-gray-200">
//                       {data.filing_status.map((f, i) => (
//                         <div key={i} className="pt-2 flex flex-col md:flex-row md:justify-between text-sm text-gray-700">
//                           <span className="font-semibold text-indigo-600">{f.return_type}</span>
//                           <span>{f.financial_year} <span className="text-gray-500 text-xs">({f.tax_period})</span></span>
//                           <span className={`font-bold ${f.status === 'FILED' ? 'text-green-600' : 'text-yellow-600'}`}>
//                             {f.status}
//                           </span>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </>
//             )}

//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-6 font-sans">
//       <div className="max-w-6xl mx-auto bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden flex flex-col md:flex-row">
        
//         {/* SIDEBAR TABS */}
//         <div className="w-full md:w-1/3 bg-[#12345A] text-white flex flex-col">
//           <div className="p-6 border-b border-[#1c4d85]">
//             <h2 className="text-2xl font-bold tracking-wide">Verification Hub</h2>
//             <p className="text-sm text-gray-300 mt-1">Select a service to verify identity</p>
//           </div>
//           <div className="flex-1 overflow-y-auto p-4 space-y-2 max-h-[400px] md:max-h-[650px]">
//             {Object.entries(servicesConfig).map(([key, config]) => (
//               <button
//                 key={key}
//                 onClick={() => handleTabSwitch(key)}
//                 className={`w-full text-left px-4 py-3 rounded-lg transition-all duration-300 font-medium ${
//                   activeTab === key
//                     ? "bg-white text-[#12345A] shadow-md"
//                     : "text-gray-300 hover:bg-[#1c4d85] hover:text-white"
//                 }`}
//               >
//                 {config.title}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* MAIN CONTENT AREA */}
//         <div className="w-full md:w-2/3 p-8">
//           <h3 className="text-3xl font-bold text-[#12345A] mb-6 border-b pb-4">
//             {activeService.title}
//           </h3>

//           {/* DYNAMIC FORM */}
//           <form onSubmit={handleSubmit} className="space-y-6 max-w-lg">
//             {activeService.fields.map((field) => (
//               <div key={field.name} className="flex flex-col">
//                 <label className="text-sm font-semibold text-[#12345A] mb-2">
//                   {field.label}
//                 </label>
//                 <input
//                   type={field.type || "text"}
//                   name={field.name}
//                   value={formData[field.name] || ""}
//                   onChange={handleInputChange}
//                   placeholder={field.placeholder}
//                   required
//                   className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#12345A] focus:border-transparent transition-all"
//                 />
//               </div>
//             ))}

//             {activeService.note && (
//               <div className="p-3 rounded-lg text-sm font-medium bg-blue-50 text-blue-700 border border-blue-200">
//                 {activeService.note}
//               </div>
//             )}

//             <button
//               type="submit"
//               disabled={activeService.loading}
//               className="w-full bg-[#12345A] text-white font-bold py-3 px-4 rounded-lg hover:bg-[#0d2644] transition-all disabled:opacity-70 disabled:cursor-not-allowed flex justify-center items-center"
//             >
//               {activeService.loading ? (
//                 <span className="animate-pulse flex items-center">
//                   <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                   </svg>
//                   Verifying...
//                 </span>
//               ) : (
//                 "Verify Now"
//               )}
//             </button>
//           </form>

//           {/* ERROR DISPLAY */}
//           {errorMsg && (
//             <div className="mt-8 p-4 bg-red-50 border-l-4 border-red-500 rounded-r-lg shadow-sm">
//               <div className="flex items-center">
//                 <svg className="w-6 h-6 text-red-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
//                 </svg>
//                 <h4 className="text-lg font-bold text-red-800">Verification Failed</h4>
//               </div>
//               <p className="mt-2 text-red-700 font-medium ml-8">{errorMsg}</p>
//             </div>
//           )}

//           {/* CLEAN RESULTS DISPLAY */}
//           {renderCleanResults()}

//         </div>
//       </div>
//     </div>
//   );
// };

// export default Verification;






import React, { useState } from "react";
import { useSelector } from "react-redux";
import useApi from "../../CustomHooks/useApi";
import {
  ArrowLeft,
  Search,
  CheckCircle2,
  AlertCircle,
  Loader2,
  Sparkles,
  CreditCard,
  Link,
  Landmark,
  Smartphone,
  UserCheck,
  FileText,
  Car,
  Building2,
  Briefcase,
  ShieldCheck,
  FileBadge,
  UserCircle
} from "lucide-react";

const Verification = () => {
  const merchantdetails = useSelector((state) => state.auth?.employeeDetails);
  const username = merchantdetails?.username || "";

  /* ================= HOOKS: ORIGINAL APIS ================= */
  const { callApi: verifyPan, loading: loadingPan } = useApi("/kyc/verify/pan", "POST");
  const { callApi: verifyPanAadhaarLink, loading: loadingLink } = useApi("/kyc/verify/pan-aadhaar-link", "POST");
  const { callApi: verifyBenePennyless, loading: loadingPennyless } = useApi("/kyc/verify/bene/pennyless", "POST");
  const { callApi: verifyBenePennyDrop, loading: loadingPennyDrop } = useApi("/kyc/verify/bene/penny-drop", "POST");
  const { callApi: verifyMobileToUpi, loading: loadingMobile } = useApi("/kyc/verify/mobile-to-upi", "POST");
  const { callApi: verifyUpi, loading: loadingUpi } = useApi("/kyc/verify/upi", "POST");

  /* ================= HOOKS: NEW QUICK-EKYC APIS ================= */
  const { callApi: apiAadhaarMobileLink, loading: loadingAadhMobile } = useApi("/quick-ekyc/aadhaar/mobile-link", "POST");
  const { callApi: apiVoterIdVerify, loading: loadingVoter } = useApi("/quick-ekyc/voter-id/verify", "POST");
  const { callApi: apiMaskedPanVerify, loading: loadingMaskedPan } = useApi("/quick-ekyc/pan/masked-verify", "POST");
  const { callApi: apiRationCardVerify, loading: loadingRation } = useApi("/quick-ekyc/ration-card/verify", "POST");
  const { callApi: apiDrivingLicenseVerify, loading: loadingDl } = useApi("/quick-ekyc/driving-license/verify", "POST");
  const { callApi: apiPanAadhaarLinked, loading: loadingPanLinked } = useApi("/quick-ekyc/pan/linked", "POST");
  
  /* ================= HOOKS: NEWLY ADDED APIS ================= */
  const { callApi: apiPanValidation, loading: loadingPanVal } = useApi("/quick-ekyc/pan/validate", "POST");
  const { callApi: apiAadhaarToPan, loading: loadingAadhaarPan } = useApi("/quick-ekyc/aadhaar/to-pan", "POST");
  const { callApi: apiMobileUpiAdvance, loading: loadingMobileUpiAdv } = useApi("/quick-ekyc/mobile/to-upi-advance", "POST");
  const { callApi: apiChallanVerify, loading: loadingChallan } = useApi("/quick-ekyc/vehicle/challan", "POST");
  const { callApi: apiUdyogAadhaar, loading: loadingUdyog } = useApi("/quick-ekyc/business/udyog-aadhaar", "POST");
  const { callApi: apiDinVerify, loading: loadingDin } = useApi("/quick-ekyc/business/din", "POST");
  const { callApi: apiCinVerify, loading: loadingCin } = useApi("/quick-ekyc/business/cin", "POST");
  const { callApi: apiGstinVerify, loading: loadingGstin } = useApi("/quick-ekyc/business/gstin", "POST");

  // If activeTab is null, we show the grid. If it has a string key, we show the form.
  const [activeTab, setActiveTab] = useState(null); 
  const [formData, setFormData] = useState({});
  const [resultData, setResultData] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const servicesConfig = {
    /* ----- IDENTITY SERVICES ----- */
    pan: {
      title: "PAN Verification",
      desc: "Verify identity via Permanent Account Number",
      category: "Identity",
      icon: CreditCard,
      color: "text-blue-600 bg-blue-50 border-blue-100",
      fields: [{ name: "panNumber", label: "PAN Number", placeholder: "e.g. AAICP3293R" }],
      apiCall: verifyPan,
      loading: loadingPan,
      note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
    },
    panValidation: {
      title: "PAN Validation Check",
      desc: "Validates PAN details and categorization.",
      category: "Identity",
      icon: ShieldCheck,
      color: "text-sky-600 bg-sky-50 border-sky-100",
      fields: [{ name: "panNumber", label: "PAN Number", placeholder: "e.g. ABCDE1234F" }],
      apiCall: apiPanValidation,
      loading: loadingPanVal,
      note: "⚡ Quick eKYC verification hub service.",
    },
    maskedPanVerify: {
      title: "Masked PAN Verification",
      desc: "Securely retrieve masked PAN details",
      category: "Identity",
      icon: FileBadge,
      color: "text-indigo-600 bg-indigo-50 border-indigo-100",
      fields: [{ name: "panNumber", label: "PAN Number", placeholder: "e.g. ABCDE1234F" }],
      apiCall: apiMaskedPanVerify,
      loading: loadingMaskedPan,
      note: "⚡ Quick eKYC verification hub service.",
    },
    panAadhaar: {
      title: "PAN-Aadhaar Link Check",
      desc: "Check if a PAN is linked to a specific Aadhaar",
      category: "Identity",
      icon: Link,
      color: "text-violet-600 bg-violet-50 border-violet-100",
      fields: [
        { name: "pan", label: "PAN Number", placeholder: "e.g. GDCPS0678M" },
        { name: "aadhaar", label: "Aadhaar Number", placeholder: "12-digit number" },
      ],
      apiCall: verifyPanAadhaarLink,
      loading: loadingLink,
      note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
    },
    panLinkedCheck: {
      title: "PAN Link State",
      desc: "Check Aadhaar linkage status of a PAN",
      category: "Identity",
      icon: Link,
      color: "text-purple-600 bg-purple-50 border-purple-100",
      fields: [{ name: "panNumber", label: "PAN Number", placeholder: "e.g. ABCDE1234F" }],
      apiCall: apiPanAadhaarLinked,
      loading: loadingPanLinked,
      note: "⚡ Quick eKYC verification hub service.",
    },
    aadhaarToPan: {
      title: "Aadhaar to PAN Lookup",
      desc: "Fetch linked PAN details directly from Aadhaar",
      category: "Identity",
      icon: UserCheck,
      color: "text-fuchsia-600 bg-fuchsia-50 border-fuchsia-100",
      fields: [{ name: "aadhaarNumber", label: "Aadhaar Number", placeholder: "Enter 12-digit Number" }],
      apiCall: apiAadhaarToPan,
      loading: loadingAadhaarPan,
      note: "⚡ Quick eKYC verification hub service.",
    },
    aadhaarMobileLink: {
      title: "Aadhaar-Mobile Link",
      desc: "Check if a mobile is linked to an Aadhaar",
      category: "Identity",
      icon: Smartphone,
      color: "text-rose-600 bg-rose-50 border-rose-100",
      fields: [{ name: "aadhaarNumber", label: "Aadhaar Number", placeholder: "Enter 12-digit Number" }],
      apiCall: apiAadhaarMobileLink,
      loading: loadingAadhMobile,
      note: "⚡ Quick eKYC verification hub service.",
    },
    voterIdVerify: {
      title: "Voter ID Verification",
      desc: "Verify identity via EPIC / Voter ID",
      category: "Identity",
      icon: UserCircle,
      color: "text-orange-600 bg-orange-50 border-orange-100",
      fields: [{ name: "voterIdNumber", label: "Voter ID / EPIC Number", placeholder: "e.g. ABC1234567" }],
      apiCall: apiVoterIdVerify,
      loading: loadingVoter,
      note: "⚡ Quick eKYC verification hub service.",
    },
    rationCardVerify: {
      title: "Ration Card Check",
      desc: "Fetch Ration Card and family member details",
      category: "Identity",
      icon: FileText,
      color: "text-amber-600 bg-amber-50 border-amber-100",
      fields: [{ name: "rationCardNumber", label: "Ration Card Number", placeholder: "Enter Ration Card No." }],
      apiCall: apiRationCardVerify,
      loading: loadingRation,
      note: "⚡ Quick eKYC verification hub service.",
    },
    drivingLicenseVerify: {
      title: "Driving License Verify",
      desc: "Verify regional driving license records",
      category: "Identity",
      icon: Car,
      color: "text-emerald-600 bg-emerald-50 border-emerald-100",
      fields: [
        { name: "licenseNumber", label: "Driving License Number", placeholder: "e.g. HR0120230012345" },
        { name: "dob", label: "Date of Birth", placeholder: "YYYY-MM-DD", type: "date" }
      ],
      apiCall: apiDrivingLicenseVerify,
      loading: loadingDl,
      note: "⚡ Quick eKYC verification hub service.",
    },

    /* ----- BANKING & UPI SERVICES ----- */
    benePennyless: {
      title: "Bank Account (Penny-Less)",
      desc: "Verify bank account holder name without pennyless",
      category: "Banking",
      icon: Landmark,
      color: "text-teal-600 bg-teal-50 border-teal-100",
      fields: [
        { name: "accountNumber", label: "Account Number", placeholder: "e.g. 1234567890" },
        { name: "ifsc", label: "IFSC Code", placeholder: "e.g. HDFC0001234" },
      ],
      apiCall: verifyBenePennyless,
      loading: loadingPennyless,
      note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
    },
    benePennyDrop: {
      title: "Bank Account (Penny Drop)",
      desc: "Verify bank account holder name with penny drop",
      category: "Banking",
      icon: Landmark,
      color: "text-cyan-600 bg-cyan-50 border-cyan-100",
      fields: [
        { name: "accountNumber", label: "Account Number", placeholder: "e.g. 1234567890" },
        { name: "ifsc", label: "IFSC Code", placeholder: "e.g. HDFC0001234" },
      ],
      apiCall: verifyBenePennyDrop,
      loading: loadingPennyDrop,
      note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
    },
    mobileUpi: {
      title: "Mobile to UPI Lookup",
      desc: "Find UPI ID associated with a mobile number",
      category: "Banking",
      icon: Smartphone,
      color: "text-sky-600 bg-sky-50 border-sky-100",
      fields: [{ name: "mobileNumber", label: "Mobile Number", placeholder: "10-digit number" }],
      apiCall: verifyMobileToUpi,
      loading: loadingMobile,
      note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
    },
    mobileUpiAdvance: {
      title: "Mobile to UPI Advance",
      desc: "Retrieves multiple linked UPI IDs across banks",
      category: "Banking",
      icon: Smartphone,
      color: "text-blue-600 bg-blue-50 border-blue-100",
      fields: [{ name: "mobileNumber", label: "Mobile Number", placeholder: "10-digit number" }],
      apiCall: apiMobileUpiAdvance,
      loading: loadingMobileUpiAdv,
      note: "⚡ Quick eKYC verification hub service.",
    },
    upi: {
      title: "UPI ID Verification",
      desc: "Verify validity and holder of a UPI ID",
      category: "Banking",
      icon: CheckCircle2,
      color: "text-indigo-600 bg-indigo-50 border-indigo-100",
      fields: [{ name: "upiId", label: "UPI ID", placeholder: "e.g. username@upi" }],
      apiCall: verifyUpi,
      loading: loadingUpi,
      note: "⚠️ Deducts ₹3 from merchant wallet before calling API.",
    },

    /* ----- BUSINESS & COMPLIANCE ----- */
    gstinVerify: {
      title: "GSTIN Verification",
      desc: "Verify Goods and Services Tax details",
      category: "Business",
      icon: Building2,
      color: "text-blue-700 bg-blue-50 border-blue-200",
      fields: [{ name: "gstinNumber", label: "GSTIN Number", placeholder: "e.g. 29ABCDE1234F1Z5" }],
      apiCall: apiGstinVerify,
      loading: loadingGstin,
      note: "⚡ Quick eKYC verification hub service.",
    },
    cinVerify: {
      title: "CIN / Company Check",
      desc: "Verify Corporate Identity Number (CIN)",
      category: "Business",
      icon: Briefcase,
      color: "text-slate-700 bg-slate-100 border-slate-200",
      fields: [{ name: "cinNumber", label: "CIN Number", placeholder: "e.g. U12345HR2015PTC..." }],
      apiCall: apiCinVerify,
      loading: loadingCin,
      note: "⚡ Quick eKYC verification hub service.",
    },
    dinVerify: {
      title: "DIN Lookup",
      desc: "Director Identification Number check",
      category: "Business",
      icon: UserCheck,
      color: "text-violet-700 bg-violet-50 border-violet-200",
      fields: [{ name: "dinNumber", label: "DIN Number", placeholder: "Enter 8-digit DIN" }],
      apiCall: apiDinVerify,
      loading: loadingDin,
      note: "⚡ Quick eKYC verification hub service.",
    },
    udyogAadhaar: {
      title: "Udyog Aadhaar (MSME)",
      desc: "Verify MSME registration details",
      category: "Business",
      icon: ShieldCheck,
      color: "text-emerald-700 bg-emerald-50 border-emerald-200",
      fields: [{ name: "uanNumber", label: "Udyog Aadhaar Number", placeholder: "e.g. HR0123456789" }],
      apiCall: apiUdyogAadhaar,
      loading: loadingUdyog,
      note: "⚡ Quick eKYC verification hub service.",
    },
    challanVerify: {
      title: "Vehicle Challan Check",
      desc: "Check traffic challans via RC number",
      category: "Business",
      icon: Car,
      color: "text-rose-700 bg-rose-50 border-rose-200",
      fields: [{ name: "rcNumber", label: "RC Number", placeholder: "e.g. HRXXXX1234" }],
      apiCall: apiChallanVerify,
      loading: loadingChallan,
      note: "⚡ Quick eKYC verification hub service.",
    },
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const uppercaseFields = [
      "panNumber", "pan", "ifsc", "voterIdNumber", "licenseNumber", 
      "rcNumber", "udyogAadhaarNumber", "dinNumber", "cinNumber", "gstinNumber"
    ];
    const finalValue = uppercaseFields.includes(name) ? value.toUpperCase() : value;
    setFormData({ ...formData, [name]: finalValue });
  };

  const openService = (key) => {
    setActiveTab(key);
    setFormData({});
    setResultData(null);
    setErrorMsg("");
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const goBackToGrid = () => {
    setActiveTab(null);
    setFormData({});
    setResultData(null);
    setErrorMsg("");
  };
const activeService = activeTab ? servicesConfig[activeTab] : null;
  const handleSubmit = async (e) => {
    e.preventDefault();
    setResultData(null);
    setErrorMsg("");

    const activeService = servicesConfig[activeTab];
    
    try {
      const payload = { ...formData };
      if (username) {
        payload.username = username;
      }
      
      const queryString = new URLSearchParams(payload).toString();
      const response = await activeService.apiCall(null, `?${queryString}`);
      
      if (response?.error || response?.error_code || response?.status === "error" || response?.status === "failed") {
        setErrorMsg(response.message || response.error || "Verification failed.");
        return;
      }

      if (response && (response.status === "success" || response.status_code === 200)) {
        setResultData(response);
      } else {
        setErrorMsg("Unexpected response format received from server.");
      }
    } catch (err) {
      setErrorMsg(err.message || "An error occurred during verification.");
    }
  };

  const ResultCard = ({ label, value, isBoolean }) => (
    <div className="bg-slate-50 p-4 rounded-xl border border-slate-200/80 flex flex-col justify-center">
      <span className="text-[10px] text-slate-500 uppercase tracking-wider font-bold mb-1.5">
        {label}
      </span>
      {isBoolean ? (
        <span className={`text-sm font-bold ${value ? 'text-emerald-600' : 'text-rose-600'}`}>
          {value ? "✓ Yes / Verified" : "✗ No / Unverified"}
        </span>
      ) : (
        <span className="text-slate-800 font-semibold text-sm sm:text-base break-words leading-tight">
          {value || "N/A"}
        </span>
      )}
    </div>
  );

  const renderCleanResults = () => {
    if (!resultData) return null;
    const data = resultData.data || resultData; 

    return (
      <div className="mt-8 border border-emerald-200/80 rounded-2xl overflow-hidden shadow-xs bg-white animate-in fade-in slide-in-from-bottom-4 duration-300">
        <div className="bg-emerald-50/80 border-b border-emerald-200/80 px-6 py-4 flex items-center gap-3">
          <div className="p-1.5 bg-emerald-100 text-emerald-600 rounded-full">
            <CheckCircle2 className="w-5 h-5" />
          </div>
          <div>
            <h4 className="text-base font-bold text-emerald-800 leading-none">Verification Successful</h4>
            <p className="text-xs font-medium text-emerald-600 mt-1">Data securely retrieved from government/bank databases</p>
          </div>
        </div>
        
        <div className="p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
            
            {/* PAN RESULTS */}
            {activeTab === 'pan' && (
              <>
                <ResultCard label="Registered Name" value={data.fullName} />
                <ResultCard label="PAN Number" value={data.panNumber} />
                <ResultCard label="Category" value={data.category} />
              </>
            )}

            {/* PAN-AADHAAR LINK RESULTS */}
            {activeTab === 'panAadhaar' && (
              <>
                <ResultCard label="Link Status" value={data.is_linked} isBoolean={true} />
                <ResultCard label="System Message" value={data.message} />
                <ResultCard label="PAN Checked" value={data.pan_number} />
              </>
            )}

            {/* BENEFICIARY RESULTS */}
            {(activeTab === 'benePennyless' || activeTab === 'benePennyDrop') && (
              <>
                <ResultCard label="Account Holder Name" value={data.full_name || data.fullName} />
                <ResultCard label="Account Exists" value={data.account_exists || data.accountExists} isBoolean={true} />
                {data.txnRefId && <ResultCard label="Transaction Ref ID" value={data.txnRefId} />}
              </>
            )}

            {/* MOBILE TO UPI RESULTS */}
            {activeTab === 'mobileUpi' && (
              <>
                <ResultCard label="Registered Name" value={data.name} />
                <ResultCard label="UPI ID" value={data.upi_id || data.upiId} />
              </>
            )}

            {/* UPI ID RESULTS */}
            {activeTab === 'upi' && (
              <>
                <ResultCard label="Name at Bank" value={data.name_at_bank || data.nameAtBank} />
                <ResultCard label="Account Status" value={data.account_exists || data.accountExists} isBoolean={true} />
              </>
            )}

            {/* AADHAAR MOBILE LINK RESULTS */}
            {activeTab === 'aadhaarMobileLink' && (
              <>
                <ResultCard label="Aadhaar Reference" value={formData.aadhaarNumber} />
                <ResultCard label="Linked Mobile" value={data.mobile_number} />
              </>
            )}

            {/* VOTER ID VERIFY RESULTS */}
            {activeTab === 'voterIdVerify' && (
              <>
                <ResultCard label="EPIC Number" value={data.epic_no} />
                <ResultCard label="Full Name" value={data.name} />
                <ResultCard label="Local Language Name" value={data.name_v1} />
                <ResultCard label="Gender" value={data.gender} />
                <ResultCard label="Age" value={data.age} />
                <ResultCard label="Date of Birth" value={data.dob} />
                <ResultCard label="Relative Name" value={data.relation_name} />
                <ResultCard label="Relation Type" value={data.relation_type} />
                <ResultCard label="State" value={data.state} />
                <ResultCard label="District" value={data.district} />
                <ResultCard label="Assembly Constituency" value={`${data.assembly_constituency} (${data.assembly_constituency_number})`} />
                <ResultCard label="Parliamentary Constituency" value={data.parliamentary_constituency} />
                <ResultCard label="Part Details" value={`${data.part_name} (${data.part_number})`} />
                <ResultCard label="Polling Station" value={data.polling_station} />
                <ResultCard label="Serial No. in Part" value={data.slno_inpart} />
              </>
            )}

            {/* MASKED PAN VERIFY RESULTS */}
            {activeTab === 'maskedPanVerify' && (
              <>
                <ResultCard label="PAN String Check" value={data.pan_number} />
                <ResultCard label="First Name Profile" value={data.first_name} />
                <ResultCard label="Middle Name Profile" value={data.middle_name} />
                <ResultCard label="Last Name Profile" value={data.last_name} />
                <ResultCard label="Birth Date Reference" value={data.dob} />
                <ResultCard label="Gender Code" value={data.gender} />
              </>
            )}

            {/* RATION CARD VERIFY RESULTS */}
            {activeTab === 'rationCardVerify' && (
              <>
                <ResultCard label="Ration Card Identifier" value={data.ration_card_no} />
                <ResultCard label="State Base" value={data.state} />
                <ResultCard label="District Base" value={data.district} />
                {data.members && data.members.length > 0 && (
                  <div className="bg-slate-50 p-4 rounded-xl border border-slate-200 flex flex-col col-span-1 sm:col-span-2">
                    <span className="text-[10px] text-slate-500 uppercase tracking-wider font-bold mb-2">
                      Family Members List
                    </span>
                    <div className="space-y-1.5 divide-y divide-slate-200">
                      {data.members.map((m) => (
                        <div key={m.member_id} className="pt-2 flex justify-between text-sm text-slate-700 font-medium">
                          <span>{m.member_name}</span>
                          <span className="text-blue-600 text-[11px] font-bold uppercase tracking-wider bg-blue-50 px-2 py-0.5 rounded-full">
                            {m.relationship}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}

            {/* DRIVING LICENSE VERIFY RESULTS */}
            {activeTab === 'drivingLicenseVerify' && (
              <>
                <ResultCard label="License ID String" value={data.license_number} />
                <ResultCard label="Holder Name" value={data.name} />
                <ResultCard label="Father / Husband Name" value={data.father_or_husband_name} />
                <ResultCard label="Gender Check" value={data.gender} />
                <ResultCard label="Birth Date Check" value={data.dob} />
                <ResultCard label="Issue Date (DOI)" value={data.doi} />
                <ResultCard label="Expiry Date (DOE)" value={data.doe} />
                <ResultCard label="State Location" value={data.state} />
                <ResultCard label="Permanent Address" value={data.permanent_address} />
                <ResultCard label="Postal ZIP Code" value={data.permanent_zip} />
                <ResultCard label="Blood Group Category" value={data.blood_group} />
                <ResultCard label="Vehicle Permitted Classes" value={data.vehicle_classes?.join(", ")} />
              </>
            )}

            {/* PAN LINKED (AADHAAR LINKAGE) RESULTS */}
            {activeTab === 'panLinkedCheck' && (
              <ResultCard label="Link Status Verified" value={data.is_linked} isBoolean={true} />
            )}

            {/* PAN VALIDATION */}
            {activeTab === 'panValidation' && (
              <ResultCard label="PAN Validation Status" value={data.is_valid} isBoolean={true} />
            )}

            {/* AADHAAR TO PAN */}
            {activeTab === 'aadhaarToPan' && (
              <>
                <ResultCard label="Linked PAN Number" value={data.pan_number} />
                <ResultCard label="Holder Name" value={data.name} />
                <ResultCard label="Date of Birth" value={data.dob} />
                <ResultCard label="Gender" value={data.gender} />
              </>
            )}

            {/* MOBILE TO UPI ADVANCE */}
            {activeTab === 'mobileUpiAdvance' && (
              <>
                <ResultCard label="UPI ID" value={data.upi_id} />
                <ResultCard label="Account Holder Name" value={data.name} />
                <ResultCard label="Bank Name" value={data.branch_name} />
                <ResultCard label="IFSC Code" value={data.ifsc_code} />
                <ResultCard label="Branch Address" value={data.branch_address} />
              </>
            )}

            {/* CHALLAN VERIFY */}
            {activeTab === 'challanVerify' && (
              <>
                <ResultCard label="Owner Name" value={data.owner_name} />
                <ResultCard label="RC Number" value={formData.rcNumber || "N/A"} />
                
                {data.challan_data && data.challan_data.length > 0 ? (
                  <div className="bg-slate-50 p-4 rounded-xl border border-slate-200 flex flex-col col-span-1 sm:col-span-2">
                    <span className="text-[10px] text-slate-500 uppercase tracking-wider font-bold mb-3">Vehicle Challans</span>
                    <div className="space-y-4 divide-y divide-slate-200">
                      {data.challan_data.map((c, i) => (
                        <div key={i} className="pt-4 grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-slate-700">
                          <div><span className="text-xs font-bold text-slate-400">Challan No:</span> <br/><span className="font-semibold">{c.challan_no}</span></div>
                          <div><span className="text-xs font-bold text-slate-400">Amount:</span> <br/><span className="font-bold text-rose-600">₹{c.challan_amount}</span></div>
                          <div><span className="text-xs font-bold text-slate-400">Date & Time:</span> <br/><span className="font-semibold">{c.challan_time}</span></div>
                          <div>
                            <span className="text-xs font-bold text-slate-400">Status: </span><br/>
                            <span className={`inline-flex px-2 py-0.5 rounded-md text-[10px] font-bold uppercase mt-1 ${c.challan_status === 'Paid' ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700'}`}>
                              {c.challan_status}
                            </span>
                          </div>
                          <div><span className="text-xs font-bold text-slate-400">State:</span> <br/><span className="font-semibold">{c.state_code}</span></div>
                          <div><span className="text-xs font-bold text-slate-400">Paid Date:</span> <br/><span className="font-semibold">{c.challan_paid_date || "N/A"}</span></div>
                          <div className="col-span-1 md:col-span-2"><span className="text-xs font-bold text-slate-400">Offence:</span> <br/><span className="font-semibold">{c.challan_info}</span></div>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="col-span-1 sm:col-span-2">
                    <ResultCard label="Challans" value="No pending challans found." />
                  </div>
                )}
              </>
            )}

            {/* UDYOG AADHAAR */}
            {activeTab === 'udyogAadhaar' && (
              <>
                <ResultCard label="Udyog Aadhaar Number" value={data.udyog_aadhaar_number} />
                <ResultCard label="Enterprise Name" value={data.enterprise_name} />
                <ResultCard label="Owner Name" value={data.owner_name} />
                <ResultCard label="Category" value={data.category} />
                <ResultCard label="Type" value={data.type} />
                <ResultCard label="NIC 2-Digit Code" value={data.nic_2_digit_code} />
                <ResultCard label="Major Activity" value={data.major_activity} />
                <ResultCard label="Commencement Date" value={data.date_of_commencement} />
                <ResultCard label="State" value={data.state} />
                <ResultCard label="District" value={data.district} />
                <ResultCard label="PIN Code" value={data.pin_code} />
                <ResultCard label="Bank Name" value={data.bank_name} />
                <ResultCard label="Bank IFSC" value={data.bank_ifsc} />
                <ResultCard label="Bank Account" value={data.bank_account} />
              </>
            )}

            {/* DIN VERIFY */}
            {activeTab === 'dinVerify' && (
              <>
                <ResultCard label="DIN Number" value={data.din_number} />
                <ResultCard label="Full Name" value={data.full_name} />
                <ResultCard label="Father's Name" value={data.father_name} />
                <ResultCard label="Date of Birth" value={data.dob} />
                <ResultCard label="Nationality" value={data.nationality} />
                <ResultCard label="PAN Associated" value={data.pan_number || "N/A"} />
                <ResultCard label="Email" value={data.email || "N/A"} />
                <ResultCard label="API Status" value={data.status} />
                
                {(data.present_address || data.permanent_address) && (
                  <div className="col-span-1 sm:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-3.5">
                    <ResultCard label="Present Address" value={data.present_address || "N/A"} />
                    <ResultCard label="Permanent Address" value={data.permanent_address || "N/A"} />
                  </div>
                )}

                {data.companies_associated && data.companies_associated.length > 0 && (
                  <div className="bg-slate-50 p-4 rounded-xl border border-slate-200 flex flex-col col-span-1 sm:col-span-2">
                    <span className="text-[10px] text-slate-500 uppercase tracking-wider font-bold mb-2">Associated Companies</span>
                    <div className="space-y-1.5 divide-y divide-slate-200">
                      {data.companies_associated.map((comp, i) => (
                        <div key={i} className="pt-2 flex flex-col sm:flex-row sm:justify-between text-sm text-slate-700">
                          <span className="font-bold">{comp.company_name || comp.name || "Company Name Unavailable"}</span>
                          {comp.cin && <span className="text-blue-600 mt-0.5 sm:mt-0 font-mono text-xs font-semibold">CIN: {comp.cin}</span>}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}

            {/* CIN VERIFY */}
            {activeTab === 'cinVerify' && (
              <>
                <ResultCard label="CIN" value={data.details?.company_info?.cin || data.company_id} />
                <ResultCard label="Company Name" value={data.company_name} />
                <ResultCard label="Company Status" value={data.details?.company_info?.company_status} />
                <ResultCard label="Company Type" value={data.company_type} />
                <ResultCard label="Company Category" value={data.details?.company_info?.company_category} />
                <ResultCard label="Class of Company" value={data.details?.company_info?.class_of_company} />
                <ResultCard label="Date of Incorporation" value={data.details?.company_info?.date_of_incorporation} />
                <ResultCard label="Email" value={data.details?.company_info?.email_id} />
                <ResultCard label="Paid Up Capital" value={data.details?.company_info?.paid_up_capital ? `₹${Number(data.details.company_info.paid_up_capital).toLocaleString()}` : "N/A"} />
                <ResultCard label="Registered Address" value={data.details?.company_info?.registered_address} />
                
                {data.details?.directors && data.details.directors.length > 0 && (
                  <div className="bg-slate-50 p-4 rounded-xl border border-slate-200 flex flex-col col-span-1 sm:col-span-2">
                    <span className="text-[10px] text-slate-500 uppercase tracking-wider font-bold mb-2">Company Directors</span>
                    <div className="space-y-1.5 divide-y divide-slate-200">
                      {data.details.directors.map((d, i) => (
                        <div key={i} className="pt-2 flex flex-col sm:flex-row sm:justify-between text-sm text-slate-700">
                          <span className="font-bold">{d.director_name}</span>
                          <span className="text-blue-600 mt-0.5 sm:mt-0 font-medium text-xs">
                            Since {d.start_date} <span className="text-slate-400 font-mono ml-1">(DIN: {d.din_number})</span>
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}

            {/* GSTIN VERIFY */}
            {activeTab === 'gstinVerify' && (
              <>
                <ResultCard label="GSTIN" value={data.gstin} />
                <ResultCard label="Legal Name" value={data.legal_name} />
                <ResultCard label="Business Name" value={data.business_name} />
                <ResultCard label="GSTIN Status" value={data.gstin_status} />
                <ResultCard label="Taxpayer Type" value={data.taxpayer_type} />
                <ResultCard label="Constitution of Business" value={data.constitution_of_business} />
                <ResultCard label="Registration Date" value={data.date_of_registration} />
                <ResultCard label="Cancellation Date" value={data.date_of_cancellation !== "1800-01-01" ? data.date_of_cancellation : "N/A"} />
                <ResultCard label="State Jurisdiction" value={data.state_jurisdiction} />
                <ResultCard label="Centre Jurisdiction" value={data.center_jurisdiction} />
                <ResultCard label="Address" value={data.address} />
                <ResultCard label="Nature of Business" value={data.nature_bus_activities?.join(", ") || "N/A"} />
                <div className="col-span-1 sm:col-span-2">
                  <ResultCard label="Core Business Activity" value={data.nature_of_core_business_activity_description} />
                </div>
                
                {data.filing_status && data.filing_status.length > 0 && data.filing_status[0].length > 0 && (
                  <div className="bg-slate-50 p-4 rounded-xl border border-slate-200 flex flex-col col-span-1 sm:col-span-2">
                    <span className="text-[10px] text-slate-500 uppercase tracking-wider font-bold mb-2">Recent GST Filing Status</span>
                    <div className="space-y-2 divide-y divide-slate-200">
                      {data.filing_status[0].map((f, i) => (
                        <div key={i} className="pt-2 flex flex-col md:flex-row md:justify-between md:items-center text-sm text-slate-700 gap-1 md:gap-0">
                          <span className="font-bold text-blue-600 bg-blue-50 px-2 py-0.5 rounded-md w-fit">{f.return_type}</span>
                          <span className="font-medium text-slate-600">{f.financial_year} <span className="text-slate-400 text-xs">({f.tax_period})</span></span>
                          <span className="text-xs text-slate-500">Filed: {f.date_of_filing}</span>
                          <span className={`inline-flex px-2 py-0.5 rounded-md text-[10px] font-bold uppercase w-fit ${f.status === 'Filed' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`}>
                            {f.status}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}

          </div>
        </div>
      </div>
    );
  };

  const getFilteredKeys = (category) => {
    return Object.keys(servicesConfig).filter(
      (key) => 
        servicesConfig[key].category === category &&
        (servicesConfig[key].title.toLowerCase().includes(searchQuery.toLowerCase()) ||
         servicesConfig[key].desc.toLowerCase().includes(searchQuery.toLowerCase()))
    );
  };

  const categories = ["Identity", "Banking", "Business"];

  return (
    <div className="min-h-screen bg-[#F8FAFC] p-4 sm:p-6 lg:p-8 space-y-6">
      
      {/* ================= HEADER ================= */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-100 mb-2">
            <ShieldCheck className="w-3.5 h-3.5" />
            Centralized eKYC & Verification
          </div>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-800 tracking-tight">
            Verification Hub
          </h1>
          <p className="text-xs sm:text-sm text-slate-500 font-medium mt-0.5">
            Select an option below to securely verify identities, bank accounts, or corporate entities.
          </p>
        </div>

        {/* Show search only on Grid View */}
        {!activeTab && (
          <div className="relative w-full sm:w-72">
            <Search className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              placeholder="Search services..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 bg-white border border-slate-200/80 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 rounded-2xl text-xs font-semibold text-slate-700 placeholder-slate-400 outline-hidden transition shadow-2xs"
            />
          </div>
        )}
      </div>

      {/* ================= VIEW 1: GRID VIEW ================= */}
      {!activeTab && (
        <div className="space-y-8 animate-in fade-in duration-300">
          {categories.map((category) => {
            const keys = getFilteredKeys(category);
            if (keys.length === 0) return null;

            return (
              <div key={category} className="space-y-4">
                <h3 className="text-sm font-bold uppercase tracking-wider text-slate-400 pl-1 border-b border-slate-200/70 pb-2">
                  {category} Verifications
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5">
                  {keys.map((key) => {
                    const svc = servicesConfig[key];
                    const Icon = svc.icon;
                    return (
                      <div
                        key={key}
                        onClick={() => openService(key)}
                        className="group bg-white rounded-3xl p-5 border border-slate-200/80 shadow-xs hover:shadow-xl hover:border-blue-500/30 hover:-translate-y-1 transition-all duration-200 cursor-pointer flex flex-col h-full"
                      >
                        <div className="flex items-start gap-4 mb-3">
                          <div className={`p-3 rounded-2xl border ${svc.color} group-hover:scale-110 transition-transform duration-200`}>
                            <Icon className="w-5 h-5" />
                          </div>
                          <div className="flex-1 mt-1">
                            <h4 className="text-sm font-bold text-slate-800 leading-tight group-hover:text-blue-600 transition-colors">
                              {svc.title}
                            </h4>
                          </div>
                        </div>
                        <p className="text-xs text-slate-500 font-medium leading-relaxed mt-auto line-clamp-2">
                          {svc.desc}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ================= VIEW 2: FORM / DETAIL VIEW ================= */}
      {activeTab && (
        <div className="bg-white rounded-3xl border border-slate-200/80 shadow-sm p-4 sm:p-6 lg:p-8 animate-in slide-in-from-right-8 duration-300">
          
          {/* Back Button & Header */}
          <div className="flex items-center gap-4 mb-8 pb-6 border-b border-slate-100">
            <button
              onClick={goBackToGrid}
              className="p-2.5 rounded-xl bg-slate-50 hover:bg-slate-100 text-slate-600 border border-slate-200/70 transition active:scale-95"
              title="Go Back"
            >
              <ArrowLeft className="w-5 h-5" />
            </button>
            <div className="flex items-center gap-3">
              <div className={`p-2 rounded-xl border ${activeService.color}`}>
                <activeService.icon className="w-5 h-5" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-slate-800 leading-tight">{activeService.title}</h2>
                <p className="text-xs text-slate-500 font-medium mt-0.5">{activeService.desc}</p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
            
            {/* Form Section */}
            <div className="lg:col-span-4 space-y-6">
              <form onSubmit={handleSubmit} className="space-y-5 bg-slate-50/50 p-5 sm:p-6 rounded-2xl border border-slate-100">
                {activeService.fields.map((field) => (
                  <div key={field.name} className="space-y-1.5">
                    <label className="text-xs font-bold uppercase tracking-wider text-slate-600">
                      {field.label}
                    </label>
                    <input
                      type={field.type || "text"}
                      name={field.name}
                      value={formData[field.name] || ""}
                      onChange={handleInputChange}
                      placeholder={field.placeholder}
                      required
                      className="w-full px-4 py-3 bg-white border border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 rounded-xl text-sm font-semibold text-slate-800 placeholder-slate-400 outline-hidden transition-all shadow-2xs"
                    />
                  </div>
                ))}

                {activeService.note && (
                  <div className="flex items-start gap-2.5 p-3.5 rounded-xl bg-blue-50 border border-blue-100/50">
                    <Sparkles className="w-4 h-4 text-blue-500 shrink-0 mt-0.5" />
                    <p className="text-[11px] font-semibold text-blue-700 leading-snug">
                      {activeService.note}
                    </p>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={activeService.loading}
                  className="w-full py-3.5 px-4 bg-slate-900 hover:bg-slate-800 text-white text-sm font-bold rounded-xl shadow-md shadow-slate-900/10 transition active:scale-95 flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
                >
                  {activeService.loading ? (
                    <>
                      <Loader2 className="w-4 h-4 animate-spin" /> Processing...
                    </>
                  ) : (
                    "Verify Now"
                  )}
                </button>
              </form>

              {/* Error Message */}
              {errorMsg && (
                <div className="p-4 rounded-xl bg-rose-50 border border-rose-200 flex items-start gap-3 animate-in fade-in duration-200">
                  <AlertCircle className="w-5 h-5 text-rose-600 shrink-0 mt-0.5" />
                  <div>
                    <h4 className="text-sm font-bold text-rose-800 leading-none mb-1">Verification Failed</h4>
                    <p className="text-xs font-medium text-rose-600">{errorMsg}</p>
                  </div>
                </div>
              )}
            </div>

            {/* Results Section */}
            <div className="lg:col-span-8">
              {resultData ? (
                renderCleanResults()
              ) : (
                <div className="h-full min-h-[300px] flex flex-col items-center justify-center text-center p-8 bg-slate-50 border border-dashed border-slate-200 rounded-2xl">
                  <div className={`p-4 rounded-3xl ${activeService.color} mb-4 opacity-50`}>
                    <activeService.icon className="w-8 h-8" />
                  </div>
                  <h3 className="text-base font-bold text-slate-700">Awaiting Input</h3>
                  <p className="text-xs text-slate-500 font-medium max-w-sm mt-1">
                    Fill out the required fields and click "Verify Now" to fetch records from the central database.
                  </p>
                </div>
              )}
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default Verification;
